import { createTheme, responsiveFontSizes } from "@mui/material/styles";

const buildPalette = (b) => ({
  mode: b.mode,
  primary: { main: b.primary },
  secondary: { main: b.secondary },
  background: { default: b.bg, paper: b.card || b.bgLight },
  text: { primary: b.text_primary, secondary: b.text_secondary },
});

const typography = {
  fontFamily: "'Inter', sans-serif",
  // Large Hero Text
  h1: { fontFamily: "'Playfair Display', serif", fontWeight: 800, letterSpacing: "-0.02em" },
  h2: { fontFamily: "'Playfair Display', serif", fontWeight: 700 },
  // Section Headers
  h3: { fontFamily: "'JetBrains Mono', monospace", fontWeight: 600, letterSpacing: "0.05em", fontSize: "1.4rem" },
  h4: { fontFamily: "'JetBrains Mono', monospace", fontWeight: 500, letterSpacing: "0.05em" },
  h5: { fontFamily: "'JetBrains Mono', monospace", fontWeight: 500 },
  h6: { fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: "0.95rem" },
  body1: { lineHeight: 1.75, fontSize: "0.95rem", color: "#858d99" },
  body2: { fontSize: "0.85rem", color: "#6b7582" },
  // Monospace system labels
  caption: { fontFamily: "'JetBrains Mono', monospace", fontSize: "0.68rem", letterSpacing: "0.1em", textTransform: "uppercase" },
  button: { fontFamily: "'JetBrains Mono', monospace", fontWeight: 500, letterSpacing: "0.05em" },
};

const components = {
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: "uppercase",
        borderRadius: 0, // Sharp corners
        fontWeight: 500,
        padding: "8px 20px",
        transition: "all 0.3s ease",
        border: "1px solid transprent",
      },
      contained: {
        backgroundColor: "rgba(0, 240, 255, 0.1)",
        color: "#00f0ff",
        border: "1px solid rgba(0, 240, 255, 0.3)",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: "rgba(0, 240, 255, 0.2)",
          borderColor: "#00f0ff",
          boxShadow: "0 0 15px rgba(0, 240, 255, 0.2)",
        },
      },
      outlined: {
        borderColor: "rgba(0, 240, 255, 0.2)",
        color: "#6b7582",
        "&:hover": {
          borderColor: "#00f0ff",
          color: "#00f0ff",
          backgroundColor: "transparent",
        },
      },
      text: {
        color: "#6b7582",
        "&:hover": {
          color: "#00f0ff",
          backgroundColor: "transparent",
        },
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 0, // Tactical square corners
        backgroundImage: "none",
        backgroundColor: "rgba(5, 8, 18, 0.8)",
        border: "1px solid rgba(0, 240, 255, 0.1)",
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: { 
        borderRadius: 2, // Slightly squared
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: "0.65rem",
        letterSpacing: "0.05em",
      },
    },
  },
  MuiContainer: { defaultProps: { maxWidth: "lg" } },
};

const getMuiTheme = (b) =>
  responsiveFontSizes(createTheme({ palette: buildPalette(b), typography, components, shape: { borderRadius: 0 } }));
export default getMuiTheme;
